/**
 * Everpret RecommendationEngine
 *
 * Pure selection logic over a small candidate pool that Liquid already
 * rendered server-side (the existing `cross_sell_products` section setting —
 * reused rather than duplicated) into a <script data-recommendation-pool>
 * JSON island. No product fetching happens in JS.
 *
 * Priority: candidates that help close the gap to the next reward tier,
 * scored by closeness to the remaining amount (closest-without-exceeding
 * wins), falling back to the merchandiser's configured order when there is
 * no active reward context.
 */
(function (window) {
  'use strict';

  function readPool(root) {
    var node = (root || document).querySelector('[data-recommendation-pool]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function score(product, amountRemaining) {
    if (!amountRemaining || amountRemaining <= 0) return 0;
    var diff = Math.abs(product.price - amountRemaining);
    var bonus = product.price <= amountRemaining ? 200 : 0;
    return bonus - diff;
  }

  function selectRecommendations(root, cart, amountRemaining, limit) {
    limit = limit || 5;
    var pool = readPool(root);
    var inCart = {};
    (cart && cart.items ? cart.items : []).forEach(function (line) {
      inCart[line.product_id] = true;
    });

    return pool
      .filter(function (p) {
        return p.available && !inCart[p.productId];
      })
      .map(function (p) {
        return Object.assign({}, p, { score: score(p, amountRemaining) });
      })
      .sort(function (a, b) {
        return b.score - a.score;
      })
      .slice(0, limit);
  }

  window.Everpret = window.Everpret || {};
  window.Everpret.RecommendationEngine = { select: selectRecommendations };
})(window);
